<template lang="pug">
.pdf-document
  // @slot Default slot for the component
  slot
</template>
<script>
import * as PdfJs from 'pdfjs-dist/webpack';

/**
 * @displayName Document
 **/
export default {
  name: 'PdfDocument',
  props: {
    /** PDF file */
    src: {
      type: [String, Uint8Array],
      required: true,
    },
    /** PDF.js Worker SRC */
    workerSrc: {
      type: String,
      required: false,
      default: `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${PdfJs.version}/pdf.worker.min.js`,
    },
  },
  data() {
    return {
      document: null,
      proxyPages: [],
    };
  },
  created() {
    PdfJs.GlobalWorkerOptions.workerSrc = this.workerSrc;
    this.load();
  },
  methods: {
    async load() {
      this.document = await PdfJs.getDocument(this.src).promise;
      this.proxyPages = await this.getProxyPages();

      /**
       * Size of the element where the page was rendered
       * @event element-size
       * @property {number} width - Element width
       * @property {number} height - Element height
       */
      this.$emit('element-size', {
        width: this.width,
        height: this.height,
      });

      /**
       * Array with instances of PDFPageProxy class
       * @event proxy-pages
       * @property {array} PDFPageProxy - Page proxy
       */
      this.$emit('proxy-pages', this.proxyPages);
    },
    async getProxyPages() {
      const pages = [];
      return new Promise((resolve) => {
        for (let i = 1; i <= this.document.numPages; i++) {
          this.document.getPage(i).then((page) => {
            page.position = 0;
            pages.push(page);
            if (this.document.numPages === i) {
              resolve(pages);
            }
          });
        }
      });
    },
  },
};
</script>
<docs lang="md">
#### Usage example

Getting the number of pages in the PDF

```js
new Vue({
  data: () => ({
    proxyPages: [],
  }),
  template: `
    <document src="/assets/example.pdf" @proxy-pages="proxyPages = $event">
      <div>Total pages: {{ proxyPages.length }}</div>
    </document>
  `,
});
```
</docs>
